angular.module('pitch.app').controller('ServicesCtrl',
    function($scope, statementSlides, articles, $sce) {
        "use strict";

        $scope.statementSlides = statementSlides;
        $scope.articles = articles;

        $scope.getArticleBody = function(article) {
            return $sce.trustAsHtml(article.body);
        };
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/ServicesCtrl.js